import { LogOut, Phone, Sparkles } from "lucide-react";
import { NavLink } from "react-router-dom";


export default function TopHeader({showBookNow = false, showLogout = false}){
    return (
    <header className="bg-white/90 backdrop-blur-md shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
            <div className="flex items-center gap-2">
                <Sparkles className="w-8 h-8 text-purple-600" />
                <div>
                    <NavLink to="/">
                    <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                    EstherSpotless
                    </h1>
                    <p className="text-xs text-gray-600 italic">Perfection is Always in Season</p>
                    </NavLink>
                </div>
            </div>
            <a
                href="tel:613-805-5371"
                className="hidden md:flex items-center gap-2 text-gray-700 hover:text-purple-600 transition-colors"
            >
                <Phone className="w-5 h-5" />
                <span className="font-semibold">613-805-5371</span>
            </a>
            {(showBookNow) ? 
            (<NavLink to="/book">
                <button className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all transform hover:scale-105">
                Book Now
                </button>
            </NavLink>) : ''
            }
            {(showLogout) ?
            (<NavLink to="/"> 
            <button 
              className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-full font-semibold transition-all"
            >
              <LogOut className="w-4 h-4" />
              Logout
            </button>
            </NavLink>): ''
            }
        </div>
    </header>
    )
}